import { render, staticRenderFns } from "./VBadgeTo.vue?vue&type=template&id=517721f2&"
import script from "./VBadgeTo.vue?vue&type=script&lang=ts&"
export * from "./VBadgeTo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports